import {
  AfterViewInit,
  ContentChildren,
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  QueryList,
} from '@angular/core';
import { FormItemComponent } from '@app/_assets/formItem';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { QueryParamsService } from '@app/_services/QueryParams.service';
import { BaseInputComponent } from '@app/modules/form-inputs/components/base-input/base-input.component';

@Directive({
    selector: '[filters]',
    standalone: false
})

export class FiltersDirective implements AfterViewInit, OnDestroy {

  @ContentChildren(FormItemComponent, { descendants: true })
    formItems: QueryList<FormItemComponent>;
  @ContentChildren(BaseInputComponent, {descendants: true}) separateFormItems?: QueryList<BaseInputComponent>;
  @Input() outsideParameters: Object = {};
  @Input() removeDisabledFieldParams?: boolean;
  private paramsWatcher: Subscription = new Subscription();

  constructor(
    private el: ElementRef,
    private router: Router,
    private route: ActivatedRoute,
    private filters: QueryParamsService,
  ) {
  }

  bindEvents(): void {
    this.el.nativeElement.addEventListener('submit', (e) => {
      e.preventDefault();
      this.gatherValues();
    });
  }

  gatherValues(): void {
    let queryParams = {};
    if (this.outsideParameters) {
      queryParams = { ...this.outsideParameters };
    }
    let items = this.formItems?.toArray() as Array<BaseInputComponent | FormItemComponent>;
    items = items.concat(...(this.separateFormItems.toArray() || []));
    items.forEach((item) => {
      const data = item.getValue();
      const skipParam = this.removeDisabledFieldParams && item.disabled;
      if (data.search && !item.excludeFromSearch) {
        if (data.name && data.name !== '' && data.value && data.value !== '' && !skipParam) {
          queryParams[data.name] = data.value;
        }
      }
    });
    Object.keys(queryParams).forEach((item) => {
      if (Array.isArray(queryParams[item])) {
        queryParams[item] = queryParams[item].join(';');
        if (!queryParams[item].length) delete queryParams[item];
      }
    });

    this.router.navigate([], {
      queryParams,
    });
  }

  setValues(): void {
    const tmpParams = this.filters.getValues();
    let items = this.formItems?.toArray() as Array<BaseInputComponent | FormItemComponent>;
    items = items.concat(...(this.separateFormItems.toArray() || []));
    items?.forEach((item) => {
      const data = item.getValue();
      if (tmpParams[data.name]) {
        item.setValue(tmpParams[data.name]);
      } else {
        const val = item.type === 'multi-select' ? [] : '';
        item.setValue(val);
      }
    });
  }

  watchParams(): void {
    this.paramsWatcher = this.route.queryParams.subscribe((queryParams) => {
      this.setValues();
    });
  }

  ngAfterViewInit() {
    this.bindEvents();
    this.watchParams();
  }

  ngOnDestroy() {
    this.paramsWatcher.unsubscribe();
  }

}
